import React from "react";
import Template from "../components/Template";
import BreadCrumb from "../components/BreadCrumb";

function Yoga() {
  return (
    <Template>
      <BreadCrumb pageName="Yoga" />

      <section className="section-lgx">
        <div className="container">
          <div className="row g-0">
            <div className="col-12 pbmit-footer-right">
              <h2
                style={{
                  textAlign: "center",
                  marginBottom: "30px",
                  color: "#05AAE3",
                }}
              >
                YOGA FOR MIND & BODY
              </h2>
            </div>

            <div className="col-xl-5 col-lg-12">
              <img
                src="https://www.auromere.com/images/Yoga-Pastel-Sun-FB.jpg"
                className="img-fluid"
                style={{ width: "95%", height: "auto", margin: "0px auto" }}
                alt="Yoga Practice"
              />
            </div>

            <div
              className="col-xl-7 col-lg-12"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div>
                <div className="pbmit-heading-subheading animation-style1 mb-4">
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: 25,
                      textTransform: "uppercase",
                      display: "block",
                    }}
                  >
                    WHAT YOU’LL EXPERIENCE
                  </span>
                </div>

                <p>
                  Our yoga programs are designed to help you build flexibility,
                  strength, and inner calm through guided movement and mindful
                  breathing.
                </p>

                <p>
                  Whether you're a beginner or an experienced practitioner, our
                  sessions focus on balance, posture correction, stress relief,
                  and overall well being.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />

      <section className="section-lgx">
        <div className="container">
          <div className="row g-0">
            <div
              className="col-xl-7 col-lg-12"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div>
                <div className="pbmit-heading-subheading animation-style1 mb-4">
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: 25,
                      textTransform: "uppercase",
                    }}
                  >
                    PROGRAM HIGHLIGHTS
                  </span>
                </div>

                <p>
                  <b>LIVE ONLINE YOGA SESSIONS – 3 DAYS A WEEK</b>
                </p>

                <ul
                  className="list-group list-group-borderless"
                  style={{ marginBottom: 0 }}
                >
                  <li className="list-group-item">
                    Guided yoga flows for flexibility, strength, and relaxation
                  </li>
                  <li className="list-group-item">
                    Breathing techniques & mindfulness practices
                  </li>
                  <li className="list-group-item">
                    Access to recorded sessions if you miss a live class
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-xl-5 col-lg-12">
              <img
                src="https://www.hindustantimes.com/ht-img/img/2025/08/30/1600x900/yoga_poses_1756548307118_1756548315207.jpg"
                className="img-fluid"
                style={{ width: "95%", height: "auto", margin: "0px auto" }}
                alt="Yoga Session"
              />
            </div>
          </div>
        </div>
      </section>
      <hr />

      <section className="section-lgx">
        <div className="container">
          <div className="row g-0">
            <div className="col-xl-5 col-lg-12">
              <img
                src="https://cdn.shopify.com/s/files/1/0430/6533/files/OzQvwVeWEiOYq8VxemYHLNGyA2Sx3OJ91614347671.jpg?v=1614787195"
                className="img-fluid"
                style={{ width: "95%", height: "auto", margin: "0px auto" }}
                alt="Yoga Equipment"
              />
            </div>

            <div
              className="col-xl-7 col-lg-12"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div>
                <div className="pbmit-heading-subheading animation-style1 mb-4">
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: 25,
                      textTransform: "uppercase",
                    }}
                  >
                    EQUIPMENT REQUIRED
                  </span>
                </div>

                <ul
                  className="list-group list-group-borderless"
                  style={{ marginBottom: 0 }}
                >
                  <li className="list-group-item">Yoga mat</li>
                  <li className="list-group-item">
                    Comfortable workout clothing
                  </li>
                  <li className="list-group-item">
                    Yoga blocks or cushions (optional)
                  </li>
                  <li className="list-group-item">Water bottle & towel</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Template>
  );
}

export default Yoga;
